


































































import { Component, Vue } from 'vue-property-decorator';
import CandidatePortalLogo from './../CandidatePortalLogo.vue';

@Component({
  name: 'OnBoardingHeader',
  components: {
    CandidatePortalLogo,
  },
})
export default class OnBoardingHeader extends Vue {
  closeOnboarding() {
    this.$router.push('/home');
  }
}
